// extracted by mini-css-extract-plugin
export default {"cls1":"russia_cls1__8D19O","cls2":"russia_cls2__ul6E8","tooltip":"russia_tooltip__Re9Dr","subtitle":"russia_subtitle__Z5UdE"};